import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Text } from '../../../mo-gel';

const NavLinkClean = ({ isActive, ...props }: any) => React.createElement(NavLink as any, props);
export const StyledSubNavigation = styled.div`
  background: #000000;
  position: absolute;
  display: ${(props: any) => (props.$hover ? 'flex' : 'none')};
  right: 0;
  width: 100%;
  top: 121px;
  left: 0;
  flex-direction: column;
  z-index: 2;
`;

export const StyledImageNav = styled(NavLinkClean).withConfig({
  shouldForwardProp: function (prop: string) {
    return prop !== 'isActive';
  }
})`
  pointer-events: auto;
  padding: 10px 0;
  width: 200px;
  height: 64px;
`;

// Sub-navigation items are NavLink anchors (restore original behavior).
export const StyledSubNavItem = styled(NavLinkClean).withConfig({
  shouldForwardProp: function (prop: string) {
    return prop !== 'isActive';
  }
})`
  text-decoration: none;
  padding: 15px 40px; 
  cursor: pointer;
  text-align: left;

  margin-left: 32%;
  @media screen and (min-width: ${(props: any) => props.theme.breakpoints.xl}) {
    margin-left: 33%;
  }
`;

export const StyledLinkItem = styled.a`
  text-decoration: none;
  padding: 25px 30px;
  pointer-events: auto;

  &:hover ${StyledSubNavigation} {
    display: flex;
    flex-direction: column;
    top: 121px;
    left: 0;
    width: 100%;
  }
`;

export const StyledNavigationItem = styled(NavLinkClean).withConfig({
  shouldForwardProp: function (prop: string) {
    return prop !== 'isActive';
  }
})`
  text-decoration: none;
  padding: 25px 30px;
  pointer-events: auto;

  &:hover ${StyledSubNavigation} {
    display: flex;
    flex-direction: column;
    top: 121px;
    left: 0;
    width: 100%;
  }
`;

export const StyledNavigationItemText = styled(Text)`
  color: #ffffff;
  font-weight: bold;
`;

export const StyledHeader = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 121px;
  display: flex;
  padding: 0 51px;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  pointer-events: none;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #ffffff;

    ${StyledNavigationItemText} {
      color: #000000;
      &:hover {
        color: #006af9;
      }
    }

    ${StyledNavigationItem} {
      &:hover {
        color: #006af9;
        border-bottom: 4px solid #006af9;
      }
    }
  }
`;

export const StyledNavigationList = styled.nav`
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 100%;
  width: 70%;
`;
